import { useEffect, type RefObject } from "react";

/**
 * キーボードの上にシートを持ち上げる（#139 の【9】。#151 で pages/phone/PhoneEstimate.tsx から components/Sheet.tsx と共用に）。
 * iPhone の Safari は、キーボード（と ↑↓✓ の帯）が出ても画面の高さ（layout viewport）が変わらず、下に固定したシートがキーボードの下に隠れる →
 * 見えている範囲（visualViewport）に後ろの幕の上端と高さを合わせる。シートは幕の下に付くので、キーボードのすぐ上に来る
 * （高さも見えている範囲に収まる＝ CSS の max-height が 100% を見る）。キーボードが無いとき・拡大しているときは何もしない（inset:0 のまま）。
 * active が false のあいだは見ない（閉じているシート）
 */
export function useAboveKeyboard(ref: RefObject<HTMLElement | null>, active = true) {
  useEffect(() => {
    const vv = window.visualViewport;
    const el = ref.current;
    if (!active || !vv || !el) return;
    const apply = () => {
      const hidden = window.innerHeight - vv.height - vv.offsetTop; // 下に隠れている高さ（キーボード）
      if (Math.abs(vv.scale - 1) < 0.01 && (hidden > 1 || vv.offsetTop > 1)) {
        el.style.top = `${vv.offsetTop}px`;
        el.style.bottom = "auto";
        el.style.height = `${vv.height}px`;
        el.dataset.kb = String(Math.round(hidden));
      } else {
        el.style.removeProperty("top");
        el.style.removeProperty("bottom");
        el.style.removeProperty("height");
        delete el.dataset.kb;
      }
    };
    apply();
    vv.addEventListener("resize", apply);
    vv.addEventListener("scroll", apply);
    return () => {
      vv.removeEventListener("resize", apply);
      vv.removeEventListener("scroll", apply);
    };
  }, [ref, active]);
}
